import { Box, Theme } from "@mui/material";
import { useUser } from "@/auth/useUser";
import { IMPERSONATION_BAR_HEIGHT } from "../topBar/impersonationBar";
import { TOP_BAR_HEIGHT } from "../topBar/topBar";

type Props = {
  isOpen: boolean;
  onClose: () => void;
  drawerWidth?: string;
};

/*
This backdrop should be only used for desktop drawers as for mobile we built-in backdrop
See ./drawer.tsx hideBackdrop variable

TODO: integrate backdrop into Drawer component so it can be used universally
See waitlistDrawer.tsx for example usage
*/
export default function DrawerBackdropDesktop({
  isOpen,
  onClose,
  drawerWidth = "400px",
}: Props) {
  const { user } = useUser();

  if (!isOpen) return null;

  const isImpersonating = !!user?.impersonatedId;
  const topPosition = `calc(${TOP_BAR_HEIGHT} + ${
    isImpersonating ? IMPERSONATION_BAR_HEIGHT : "0px"
  })`;

  const commonStyles = {
    position: "fixed",
    backgroundColor: "transparent",
    zIndex: (theme: Theme) => theme.zIndex.drawer + 2,
    left: 0,
    right: drawerWidth,
  };

  return (
    <>
      {/* Backdrop covering top bar area */}
      <Box
        onClick={onClose}
        sx={{
          ...commonStyles,
          top: 0,
          bottom: `calc(100vh - ${topPosition})`,
          right: 0,
        }}
      />
      {/* Backdrop covering content area below top bar */}
      <Box
        onClick={onClose}
        sx={{
          ...commonStyles,
          top: topPosition,
          bottom: 0,
        }}
      />
    </>
  );
}
